import React, { memo } from 'react';
import { Image as Img, Platform, Pressable, Text, useWindowDimensions, View, } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, PromotionCardType } from '@voltmoney/schema';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';
/**
 * Primary UI component for user interaction
 */
const PromotionCard = ({ title, action, triggerAction, onClick, isCta = true, openCta = false, subtitle, type = PromotionCardType.DEFAULT, ctaText }) => {
    const BreakPoint = {
        Web: 1024,
    };
    const { width } = useWindowDimensions();
    const _isMobile = width < BreakPoint.Web ? true : false;
    const theme = ThemeProvider.getTheme();
    const fontFamilyMap = theme.fontFamily;
    const fontSizeMap = theme.fontSize;
    const colorMap = theme.colors;
    const handleClick = () => {
        action &&
            triggerAction &&
            triggerAction(action);
        onClick && onClick();
    };
    const handleCtaClick = () => {
        if (Platform.OS === 'web') {
            window.open('https://voltmoney.typedream.app/customer-referral-offer', '_blank');
        }
    };
    const handleTermsAndConditions = () => {
        if (Platform.OS === 'web') {
            window.open('https://voltmoney.in/invite-mfd-terms-and-condition', '_blank');
        }
    };
    const _default = () => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                paddingHorizontal: 16,
                paddingVertical: 16,
                width: '100%',
                maxWidth: 776,
                backgroundColor: '#F7F5FD',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                borderRadius: 8,
                height: _isMobile ? 'fit-content' : 190,
            } },
            React.createElement(View, { style: _isMobile
                    ? {
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                    }
                    : {
                        flex: 1,
                    } },
                React.createElement(View, { style: _isMobile
                        ? {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }
                        : {} },
                    React.createElement(Text, { style: _isMobile
                            ? {
                                fontFamily: fontFamilyMap[FontFamilyTokens.Poppins],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XXL]
                                    : fontSizeMap[FontSizeTokens.LG],
                                color: '#1D2939',
                                textAlign: 'center',
                            }
                            : {
                                fontFamily: fontFamilyMap[FontFamilyTokens.Poppins],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XXL]
                                    : fontSizeMap[FontSizeTokens.LG],
                                color: '#1D2939',
                            } },
                        "Join the mission to stop redemptions!",
                        ' '),
                    React.createElement(Text, { style: _isMobile
                            ? {
                                color: '#109648',
                                fontFamily: fontFamilyMap[FontFamilyTokens.Poppins],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XXL]
                                    : fontSizeMap[FontSizeTokens.LG],
                                textAlign: 'center',
                            }
                            : {
                                color: '#109648',
                                fontFamily: fontFamilyMap[FontFamilyTokens.Poppins],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XXL]
                                    : fontSizeMap[FontSizeTokens.LG],
                            } }, "Invite MFDs/IFAs & get an assured Family Trip To Bali"),
                    ' ',
                    _isMobile ? (React.createElement(View, { style: {
                            flexDirection: 'row',
                            paddingTop: 20,
                        } },
                        React.createElement(View, { style: {
                                width: 293,
                                height: 231,
                            } },
                            React.createElement(Img, { source: {
                                    // uri: 'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/referral_hero_image_winter23.png',
                                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Bali+Offer-1.png',
                                }, style: {
                                    width: 293,
                                    height: 231,
                                } })))) : (React.createElement(React.Fragment, null)),
                    React.createElement(View, { style: _isMobile
                            ? {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingTop: 24,
                            }
                            : {
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingTop: 24,
                            } },
                        isCta ? (React.createElement(Button, { type: ButtonTypeTokens.MediumFilled, width: ButtonWidthTypeToken.CONTENT, label: 'Know more', onPress: () => handleClick() })) : (React.createElement(React.Fragment, null)),
                        React.createElement(View, { style: _isMobile
                                ? { paddingTop: 16 }
                                : { paddingLeft: 24 } },
                            React.createElement(Pressable, { onPress: () => handleTermsAndConditions() },
                                React.createElement(Text, { style: {
                                        fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                                        fontWeight: '400',
                                        fontSize: fontSizeMap[FontSizeTokens.XS],
                                        color: colorMap[ColorTokens.Primary_100],
                                    } }, "T&C apply")))))),
            !_isMobile ? (React.createElement(View, { style: {
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                } },
                React.createElement(View, { style: {
                        width: 200,
                        height: 200,
                    } },
                    React.createElement(Img, { source: {
                            // uri: 'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/referral_hero_image_winter23.png',
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Bali+Offer-1.png'
                        }, resizeMode: 'contain', style: {
                            width: 200,
                            height: 200,
                        } })))) : (React.createElement(React.Fragment, null)))));
    const _dashboardType = () => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                paddingHorizontal: _isMobile ? 16 : 24,
                paddingVertical: _isMobile ? 16 : 24,
                width: '100%',
                maxWidth: _isMobile ? 350 : 468,
                height: _isMobile ? 126 : 158,
                backgroundColor: '#F3FAF6',
                display: 'flex',
                flexDirection: 'row',
                borderRadius: 8,
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 2,
                    justifyContent: 'center'
                } },
                title && (React.createElement(Text, { style: {
                        fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                        fontWeight: '600',
                        fontSize: _isMobile
                            ? fontSizeMap[FontSizeTokens.XS]
                            : fontSizeMap[FontSizeTokens.SM],
                        color: colorMap[ColorTokens.Grey_Night],
                        paddingBottom: _isMobile ? 10 : 16,
                    } }, title)),
                isCta && (React.createElement(Button, { type: _isMobile ? ButtonTypeTokens.MediumFilled : ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.CONTENT, label: ctaText ? ctaText : 'Get it now via WhatsApp', fontSize: _isMobile ? FontSizeTokens.XXS : FontSizeTokens.XS, onPress: () => handleClick() })),
                openCta && (React.createElement(Button, { type: _isMobile ? ButtonTypeTokens.MediumFilled : ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.CONTENT, label: ctaText ? ctaText : 'Get it now via WhatsApp', fontSize: _isMobile ? FontSizeTokens.XXS : FontSizeTokens.XS, onPress: () => handleCtaClick() })),
                subtitle && (React.createElement(Text, { style: {
                        fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                        fontWeight: '400',
                        fontSize: _isMobile
                            ? fontSizeMap[FontSizeTokens.XXS]
                            : fontSizeMap[FontSizeTokens.XS],
                        color: colorMap[ColorTokens.Grey_Charcoal],
                        paddingTop: _isMobile ? 4 : 8,
                    } }, subtitle))),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                } },
                openCta && (React.createElement(Img, { source: {
                        uri: 'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/iphone_15_banner.png'
                    }, resizeMode: 'contain', style: {
                        width: _isMobile ? 160 : 220,
                        height: _isMobile ? 160 : 220,
                    } })),
                !openCta && (React.createElement(Icon, { name: IconTokens.Brochure2, size: _isMobile ? IconSizeTokens.Size56 : IconSizeTokens.XXXXXXXXL }))))));
    const _dashboardInviteAndEarn = () => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                maxWidth: _isMobile ? 350 : 468,
                height: _isMobile ? 126 : 158,
                paddingHorizontal: _isMobile ? 12 : 24,
                paddingVertical: _isMobile ? 12 : 24,
                backgroundColor: '#F7F5FD',
                borderRadius: 8,
            } },
            React.createElement(View, { style: {
                    flex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                } },
                React.createElement(View, { style: {
                        paddingBottom: _isMobile ? 16 : 22
                    } },
                    React.createElement(Text, { style: _isMobile
                            ? {
                                fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XS]
                                    : fontSizeMap[FontSizeTokens.SM],
                                color: '#1D2939',
                            }
                            : {
                                fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XS]
                                    : fontSizeMap[FontSizeTokens.SM],
                                color: '#1D2939',
                            } },
                        "Join the mission to stop redemptions!",
                        ' '),
                    React.createElement(Text, { style: _isMobile
                            ? {
                                color: '#109648',
                                fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XS]
                                    : fontSizeMap[FontSizeTokens.SM],
                            }
                            : {
                                color: '#109648',
                                fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                                fontWeight: '600',
                                fontSize: _isMobile
                                    ? fontSizeMap[FontSizeTokens.XS]
                                    : fontSizeMap[FontSizeTokens.SM],
                            } }, "Invite MFDs/IFAs & get an assured Family Trip To Bali"),
                    ' '),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    } },
                    isCta ? (React.createElement(Button, { type: _isMobile ? ButtonTypeTokens.MediumFilled : ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.CONTENT, label: 'Know more', fontSize: _isMobile ? FontSizeTokens.XXS : FontSizeTokens.XS, onPress: () => handleClick() })) : (React.createElement(React.Fragment, null)),
                    React.createElement(View, { style: _isMobile
                            ? { paddingLeft: 16 }
                            : { paddingLeft: 24 } },
                        React.createElement(Pressable, { onPress: () => handleTermsAndConditions() },
                            React.createElement(Text, { style: {
                                    fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
                                    fontWeight: '400',
                                    fontSize: fontSizeMap[FontSizeTokens.XS],
                                    color: colorMap[ColorTokens.Primary_100],
                                } }, "T&C apply"))))),
            React.createElement(View, { style: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement(Img, { source: {
                        uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Bali+Offer-1.png',
                    }, resizeMode: 'contain', style: {
                        width: _isMobile ? 135 : 150,
                        height: 125,
                    } })))));
    return type === PromotionCardType.DASHBOARD_INVITE_AND_EARN
        ? (React.createElement(React.Fragment, null, _dashboardInviteAndEarn()))
        : type === PromotionCardType.DEFAULT
            ? (React.createElement(React.Fragment, null, _default())) : (React.createElement(React.Fragment, null, _dashboardType()));
};
export default memo(PromotionCard);
export { PromotionCard };
